/** PURE_IMPORTS_START .._.._Observable,.._.._operator_debounceTime PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { debounceTime } from '../../operator/debounceTime';
Observable.prototype.debounceTime = debounceTime;
//# sourceMappingURL=debounceTime.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/debounceTime.js
// module id = ./node_modules/rxjs/_esm5/add/operator/debounceTime.js
// module chunks = vendor